import { Component, EventEmitter, Injector, Input, OnInit, Output, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoreClass } from '@src/app/core/base/core.class';
import { MEMBER_PROFILE } from '@src/app/core/constants';
import { MASKS } from '@src/app/core/constants/masking.constants';
import { UserInformationRequest } from '@src/app/core/models/v1/requests/user.information.request.model';
import { HelperService } from '@src/app/core/services';
import moment from 'moment';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  standalone: false,
  styleUrl: './edit.component.scss'
})
export class EditComponent extends CoreClass implements OnInit {
  @Input() data: any
  @Input() timezoneData: Array<any> = []
  @Output() toggleEdit = new EventEmitter<any>()
  @Output() refresh = new EventEmitter<any>()
  helperService = inject(HelperService)
  profile_form: FormGroup
  MASKS = MASKS
  allStates: any = [];
  inputStyle = "background: rgba(239, 239, 239, 0.50);";

  genderData = [
    {
      name: "Choose an Option",
      value: null
    },
    {
      name: "Male",
      value: "MALE"
    },
    {
      name: "Female",
      value: "FEMALE"
    }
  ]
  isLoading = false;
  constructor(private fb: FormBuilder, injector: Injector) {
    super(injector)
    this.profile_form = this.fb.group({
      address: this.fb.group({
        city: [null, Validators.required],
        country: ['United States'],
        state: [null],
        addressLine1: [null, Validators.required],
        addressType: [null],
        stateId: [null,Validators.required],
        countryId: [null],
        timeZone: [null, Validators.required],
        zipCode: [null, [Validators.required, Validators.minLength(5)]]
      }),
      profile: this.fb.group({
        dateOfBirth: [null],
        email: [null],
        displayName: [null],
        firstName: [null],
        lastName: [null],
        gender: [null],
        phoneMobile: [null, { validators: [Validators.required, Validators.maxLength(10), Validators.minLength(10)] }],
        wowId: [null]
      })
    })
  }
  ngOnInit(): void {

    this.getAllStates();

    this.profile_form.controls['address'].patchValue(this.data.address)
    this.profile_form.controls['profile'].patchValue(this.data.profile)
    this.profile_form.get(['profile', 'displayName'])?.patchValue(this.data.profile.displayName)
    this.profile_form.get(['profile', 'displayName'])?.disable();
    this.profile_form.get(['profile', 'wowId'])?.disable()
    this.profile_form.get(['profile', 'email'])?.disable()
    this.profile_form.get(['profile', 'dateOfBirth'])?.patchValue(moment(this.data.profile.dateOfBirth).format('MM-DD-YYYY'))
    this.profile_form.get(['profile', 'dateOfBirth'])?.disable()
    this.profile_form.get(['profile', 'gender'])?.disable()
    this.profile_form.get(['profile', 'phoneMobile'])?.patchValue(this.data.profile.phoneMobile)
    this.profile_form.get(['address', 'country'])?.setValue('United States');
    this.profile_form.get(['address', 'country'])?.disable()

    // this.profile_form.get(['address', 'timeZone'])?.disable()
  }
  editMemberProfile = (event: any) => {
    this.profile_form.markAllAsTouched()
    if (this.profile_form.valid) {
      this.isLoading = true
      // this.sharedService.addLoader(event)
      const body = this.editObjectCreation()
      this.apiService.updateUserDetails(body)
        .subscribe(
          (response: any) => {
            this.refresh.emit(true)
            this.sharedService.removeLoader()
            this.isLoading = false
          },
          (error: any) => {
            this.sharedService.removeLoader()
          }
        )
    }
  }
  editObjectCreation = () => {
    // return {
    //   "profile": {
    //     "mobileNumber": this.profile_form.get(['profile', 'phoneMobile'])?.value
    //   },
    //   "address": {
    //     "city": this.profile_form.get(['address', 'city'])?.value,
    //     "state": this.profile_form.get(['address', 'state'])?.value,
    //     "zipCode": this.profile_form.get(['address', 'zipCode'])?.value,
    //     "timeZone": this.profile_form.get(['address', 'timeZone'])?.value
    //   }
    // }
    console.log(this.data.profile);
    
    let value: any = {
      ...this.profile_form.value,
      profile: {
        ...this.data.profile,
      },
    }
    value.profile.dateOfBirth = moment(this.data.profile.dateOfBirth, 'MMM DD, YYYY').format('YYYY-MM-DD');
    value.address.timeZone = this.profile_form.value.address.timeZone
    value.address.countryId = 231
    value.address.country = 'United States'
    value.address.stateId = Number(this.profile_form.value.address.stateId)
    value.address.state = this.allStates.find((state: any) => state.stateId === Number(this.profile_form.value.address.stateId))?.stateName
    value.profile.gender = this.data.profile.gender
    value.address.addressType = 1;
    value.profile.phoneMobile = this.profile_form.value.profile.phoneMobile;
    console.log('UPDATED',value);

    return new UserInformationRequest(value).data
  }

  onPhoneInput(event: any) {
    const input = event.target as HTMLInputElement;
    console.log(event.control);
    
    input.value = input.value.replace(/\D/g, ''); // remove non-digits
    console.log(input.value);
    event.control?.setValue(input.value, { emitEvent: false });
    console.log(event.control);
  }

  getAllStates = () => {
    this.apiService.getAllStates()
      .subscribe(
        (response: any) => {
          this.allStates = response.body.states
        }
      )
  }
}
